import * as TouchSpin from '../../jQuery/jquery.bootstrap-touchspin.js';

declare const $: any;

export class TouchSpin
{
    /**
     * Initialize touch spins
     *
     * @param selector
     */
    public static init(selector: string|HTMLElement|NodeListOf<HTMLElement>|Array<HTMLElement>) {
        let elements: NodeListOf<Element> | HTMLElement[];

        if (typeof selector === 'string') {
            elements = document.querySelectorAll(selector);
        }
        else if (selector instanceof HTMLElement) {
            elements = [selector];
        }
        else if (selector instanceof NodeList || selector instanceof Array) {
            elements = selector;
        }

        if (elements.length) {
            elements.forEach((element: HTMLElement) => {
                let min = 1,
                    max = 999;

                const form: HTMLFormElement = element.closest('form');
                if (form && form.id === 'tooth-product-form') {
                    min = 0;
                }

                const dataMin = element.dataset.min;
                const dataMax = element.dataset.max;

                if (dataMin !== undefined && dataMin !== '' && dataMin !== '0') {
                    min = parseInt(dataMin);
                }

                if (dataMax !== undefined && dataMin !== '' && dataMin !== '0') {
                    max = parseInt(dataMax);
                }

                $(element).TouchSpin({
                    verticalbuttons: true,
                    min: min,
                    max: max,
                    buttondown_class: 'btn btn-link',
                    buttonup_class: 'btn btn-link'
                });
            });
        }
    }
}
